import { Injector, inject, provideEnvironmentInitializer } from '@angular/core';

import { NoMatchRouteGuard, SECONDARY_SPORTS_ROUTES, SeoRedirectGuard, SportRoute, provideSportsWebCore } from '@frontend/sports/web/platform-lib';
import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { sportsWebProductActivateGuard, sportsWebProductDeactivateGuard } from './guards';
import { provideSportsWebHostApp } from './sports-web-host-app.provider';

const sportsWebProductBootstrap = () => {
    const injector = inject(Injector);
    const product = inject(ProductService);

    product.register(ClientConfigProductName.SPORTS, injector);
};

export const SPORTS_WEB_ROUTES: SportRoute[] = [
    {
        path: '',
        canMatch: [sportsWebProductActivateGuard],
        canDeactivate: [sportsWebProductDeactivateGuard],
        providers: [provideEnvironmentInitializer(sportsWebProductBootstrap), provideSportsWebHostApp(), provideSportsWebCore()],
        children: [
            {
                path: '',
                loadChildren: () => import('./lazy-routes').then((r) => r.INTERNAL_SPORTS_WEB_ROUTES),
            },
            {
                path: '**',
                loadComponent: () => import('@frontend/sports/common/ui/empty-component').then((c) => c.EmptyComponent),
                canActivate: [NoMatchRouteGuard, SeoRedirectGuard],
            },
        ],
    },
];

export const SPORTS_SECONDARY_ROUTES: SportRoute[] = [...SECONDARY_SPORTS_ROUTES];
